import moment from 'moment';

const CURRENT_WEEK = 1;
const NEXT_WEEK = 2;
const NEXT_WEEK_MONDAY = 8;

/**
 * Adapts channel architecture blocks into weekly FullCalendar events.
 * Broadcast clone resolution belongs at this adapter boundary.
 */
export const getWeeklyEventDate = (dayOfWeek, week, time, dayOffset = 0) => {
  // week 2 clones are the 00:00-06:00 broadcast tail of a Monday block;
  // render them in the Sunday column, clipped to the 6AM window.
  const day = week === NEXT_WEEK ? NEXT_WEEK_MONDAY : Number(dayOfWeek);

  const timeParts = String(time || '00:00:00').split(':').map(Number);
  const date = moment
    .utc()
    .startOf('isoWeek')
    .add(day - 1, 'days')
    .add(dayOffset, 'days')
    .set({
      hour: timeParts[0] || 0,
      minute: timeParts[1] || 0,
      second: timeParts[2] || 0,
      millisecond: 0,
    });

  return date.toISOString();
};

export const getWeeklyEvents = (programmes = []) =>
  programmes
    .filter((programme) => programme.week === CURRENT_WEEK || programme.week === NEXT_WEEK)
    .map((programme) => {
      const title =
        programme.seasonName ||
        programme.titleGroupName ||
        programme.seriesName ||
        programme.blockName ||
        programme.type;

      // week 2 clones are the 00:00-06:00 broadcast tail of a Monday block;
      // render them in the Sunday column, clipped to the 6AM window.
      if (programme.week === NEXT_WEEK) {
        const endTime = programme.endTime === '00:00:00' || programme.endTime > '06:00:00' ? '06:00:00' : programme.endTime;

        return {
          id: programme.id,
          title,
          start: getWeeklyEventDate(NEXT_WEEK_MONDAY, programme.week, programme.startTime || '00:00:00'),
          end: getWeeklyEventDate(NEXT_WEEK_MONDAY, programme.week, endTime),
          extendedProps: programme,
        };
      }

      const startTime = programme.startTime || '00:00:00';
      const endTime = programme.endTime || '00:00:00';
      const isOvernight = endTime === '00:00:00' || endTime <= startTime;

      return {
        id: programme.id,
        title,
        start: getWeeklyEventDate(programme.dayOfWeek, programme.week, startTime),
        end: getWeeklyEventDate(programme.dayOfWeek, programme.week, endTime, isOvernight ? 1 : 0),
        extendedProps: programme,
      };
    });
